class LSGCounter extends HTMLElement {
  constructor() {
    super();
    this.animationEnabled = this.dataset.animationEnabled === 'true';
    this.animationTarget = +this.dataset.animationTarget;
    this.animationDuration = +this.dataset.animationDuration || 5000;
    this.elCounter = this.querySelector('.lsg-counter__value');
    this.hasAnimated = false;
  }

  connectedCallback() {
    if(this.animationEnabled && this.animationTarget && this.elCounter) {
      this.handleScroll();
    }
  }

  handleScroll() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.hasAnimated = true;
          this.animateCounter(0, this.animationTarget, this.animationDuration);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(this);
  }

  formatNumber(number) {
    return number.toLocaleString();
  }

  animateCounter(start, end, duration) {
    const startTime = performance.now();

    const updateCounter = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentValue = Math.floor(progress * (end - start) + start);
      this.elCounter.textContent = this.formatNumber(currentValue);

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    };

    requestAnimationFrame(updateCounter);
  }
}

const customElementName = "lsg-counter";
if (!customElements.get(customElementName)) {
  window.customElements.define(customElementName, LSGCounter);
}